import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=f489c48a&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=f489c48a&scoped=true&lang=css&"
import style1 from "./product-details.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489c48a",
  null
  
)

export default component.exports